import { CheckListPlugin } from '@lexical/react/LexicalCheckListPlugin';
import { ListPlugin } from '@lexical/react/LexicalListPlugin';
import { TabIndentationPlugin } from '@lexical/react/LexicalTabIndentationPlugin';

import { ImportSanitizerPlugin } from './ImportSanitizerPlugin';

/**
 * Command handlers behind the toolbar's list and indent buttons, plus the paste / drop sanitiser.
 * - Each is a no-op until its command is dispatched, but must be mounted for the button to work.
 * - Rich mode only (see the registry): plain values serialise as text, which would flatten the structure.
 */
export const RichTextPlugins = () => (
  <>
    <ListPlugin hasStrictIndent />
    <CheckListPlugin />
    <TabIndentationPlugin />
    <ImportSanitizerPlugin />
  </>
);
